import { h, Component } from 'preact';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import { lerp } from 'utils/math';
import s from 'base/boltToolkit/toolkitMenu.sss';

const IconChart = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 13">
		<path d="M.61 6.252c.326 0 .589.261.587.588l-.012 3.417.012 2.172a.582.582 0 0 1-.587.587.6.6 0 0 1-.595-.594l-.007-1.285L0 11.134l.003-.935L0 9.673l.005-.003.01-2.823a.602.602 0 0 1 .5-.586zm6.587 6.177a.582.582 0 0 1-.587.587.6.6 0 0 1-.595-.594l-.011-1.957L6 10.463l.001-.666L6 9.673l.002-.001.013-6.458a.602.602 0 0 1 .5-.586l.095-.008a.583.583 0 0 1 .587.587c-.005 3.16-.01 5.31-.013 6.452l-.001.332.014 2.438zm6 0a.582.582 0 0 1-.587.587.6.6 0 0 1-.595-.594l-.014-2.599H12l.015-9.228A.602.602 0 0 1 12.61 0a.583.583 0 0 1 .587.588c-.006 5.107-.012 8.123-.015 9.048l-.001-.017.016 2.81z" />
	</svg>
);
const IconMaximize = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
		<path d="M13.403 2.437 9.425 6.415a.59.59 0 0 1-.835-.005.59.59 0 0 1-.005-.835l3.978-3.978-2.75-.015A.598.598 0 0 1 9.22.988.582.582 0 0 1 9.807.4l4.173.025a.599.599 0 0 1 .594.595l.026 4.173a.585.585 0 0 1-.588.587.598.598 0 0 1-.594-.594l-.015-2.749zM2.87 12.88l3.977-3.977a.59.59 0 0 0-.005-.834.59.59 0 0 0-.835-.006L2.03 12.041l-.015-2.749a.6.6 0 0 0-.594-.594.583.583 0 0 0-.588.587l.024 4.175a.6.6 0 0 0 .594.594l4.174.025a.585.585 0 0 0 .587-.587.599.599 0 0 0-.594-.594l-2.749-.017z" />
	</svg>
);
const IconContact = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12">
		<path d="M2.6 0C1.17 0 0 1.17 0 2.6v6.801c0 1.43 1.17 2.6 2.6 2.6h8.801c1.43 0 2.6-1.17 2.6-2.6V2.6c0-1.43-1.17-2.6-2.6-2.6zm0 1.199h8.801c.786 0 1.4.614 1.4 1.4V9.4c0 .786-.614 1.4-1.4 1.4H2.6c-.786 0-1.4-.614-1.4-1.4V2.599c0-.786.614-1.4 1.4-1.4z" />
		<path d="M6.576 7.667a.6.6 0 0 0 .848 0l4.243-4.243a.6.6 0 1 0-.848-.848L7 6.395 3.181 2.576a.6.6 0 1 0-.848.848z" />
	</svg>
);
const IconTicket = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12">
		<path d="M5.391-.008a.6.6 0 0 0-.59.608v.6a.6.6 0 1 0 1.2 0V.6a.6.6 0 0 0-.61-.608zm0 2.199a.6.6 0 0 0-.59.61v1.065a.6.6 0 1 0 1.2 0V2.8a.6.6 0 0 0-.61-.609zm0 2.666a.6.6 0 0 0-.59.61v1.065a.6.6 0 1 0 1.2 0V5.466a.6.6 0 0 0-.61-.609zm0 2.668a.6.6 0 0 0-.59.607v1.066a.6.6 0 1 0 1.2 0V8.132a.6.6 0 0 0-.61-.607zm0 2.665a.6.6 0 0 0-.59.61v.599a.6.6 0 1 0 1.2 0v-.6a.6.6 0 0 0-.61-.609z" />
		<path d="M0 0v4.443l.541.053c.673.067 1.158.684 1.158 1.404S1.233 7.162.482 7.312L0 7.407V12h14V7.407l-.483-.095c-.75-.15-1.217-.692-1.217-1.412s.466-1.262 1.217-1.412L14 4.392V-.001zm1.199 1.199h11.6v2.393c-.961.41-1.701 1.226-1.701 2.309 0 1.082.74 1.896 1.701 2.307v2.594h-11.6V8.208c.96-.41 1.701-1.225 1.701-2.307 0-1.067-.722-1.928-1.701-2.309z" />
	</svg>
);
const IconMagnifyingGlass = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
		<path d="M1.803 14.124a.583.583 0 0 1-.831.001.601.601 0 0 1-.052-.78l-.01-.021 1.22-1.211.775-.784.01.004 1.037-1.03a.6.6 0 0 1 .768-.06l.074.06a.583.583 0 0 1 0 .831l-1.872 1.859-.058.058-1.061 1.075z" />
		<path d="M12.494 2.447C10.352.305 6.86.305 4.716 2.447s-2.142 5.636 0 7.778 5.636 2.143 7.778 0 2.143-5.635 0-7.778zm-.847.848c1.684 1.684 1.684 4.398 0 6.083s-4.399 1.684-6.083 0-1.684-4.399 0-6.083a4.293 4.293 0 0 1 6.083 0z" />
	</svg>
);
const IconPlus = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15">
		<path d="M7.99.39A.6.6 0 0 0 7.4 1v5.9H1.466a.6.6 0 1 0 0 1.199H7.4v5.9a.6.6 0 1 0 1.2 0v-5.9h5.933a.6.6 0 1 0 0-1.199H8.6V1a.6.6 0 0 0-.61-.61z" />
	</svg>
);

const icons = {
	analytics: IconChart,
	campaign: IconMaximize,
	contact: IconContact,
	screenings: IconTicket,
	seo: IconMagnifyingGlass,
	learnMore: IconPlus,
};

const confettiColors = [
	'#34DC86',
	'#872CDE',
	'#F66163',
	'#BAE292',
	// '#FFFFFF',
];

export default class TooklitMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			navOpen: false,
			checkedBoxes: []
		};

		// TODO: store checked items
		// this.localStorageKey = `${props.id}-toolkit-actions`;

		this.onCheckBox = this.onCheckBox.bind(this);
		this.toggleNavOpen = this.toggleNavOpen.bind(this);
		this.navigate = this.navigate.bind(this);
	}

	// componentDidMount() {
	// 	// Restore checked items
	// }

	toggleNavOpen() {
		const { navOpen } = this.state;
		this.setState({ navOpen: !navOpen });
	}

	navigate(section) {
		this.props.scrollTo(section);
		this.toggleNavOpen();
	}

	celebrate(navItem) {
		for (let i = 0; i < 30; i++) {
			const c = document.createElement('div');
			c.classList.add(s.confetti);
			const x = Math.random();
			const y = Math.random();
			const baseA = Math.atan2(y - 1.5, x - .5);
			Object.entries({
				background: confettiColors[Math.floor(Math.random() * confettiColors.length)],
				top: (4 + y * 16) + 'px',
				left: (4 + x * 16) + 'px',
				'--vel': lerp(Math.random(), 40, 100),
				'--angle': baseA + lerp(Math.random(), -Math.PI / 10, Math.PI / 10),
				'--rotX': lerp(Math.random(), -1440, -720),
				'--rotZ': lerp(Math.random(), 720, 1440),
			}).forEach(([prop, val]) => c.style.setProperty(prop, val));

			c.addEventListener('animationend', () => c.remove());
			navItem.append(c);
		}
	}

	onCheckBox(e) {
		if (e.target.checked) {
			// this.celebrate(e.target.parentElement);
		}
	}

	renderNav(sections, checklist) {
		const { activeSection } = this.props;
		const { navOpen } = this.state;

		return (
			<div class={joinClasses(s.nav, navOpen && s.open)}>
				<h1 class={s.title}>Navigation</h1>
				<ul class={s.navItems}>
					{sortObjectByOrder(sections).map((section) => {
						if (!section.title) return;
						const isActive = activeSection === section.id;
						return (
							<li>
								<button class={joinClasses(s.navItem, isActive && s.active)} onClick={() => this.navigate(section.id)}>
									<div class={s.icon}>{icons[section.id]}</div>
									<p class={s.name}>{section.title}</p>
								</button>
							</li>
						);
					})}
				</ul>
				{this.renderChecklist(checklist)}
			</div>
		);
	}

	renderChecklist(checklist) {
		const { checkedBoxes } = this.state;
		return (
			<div class={s.checklist}>
				<h1 class={s.title}>Checklist</h1>
				<ul class={s.checklistItems}>
					{sortObjectByOrder(checklist).map(item => {
						const isActive = checkedBoxes.indexOf(item.id) !== -1;
						return (
							<li>
								<label class={joinClasses(s.navItem, isActive && s.active)}>
									<input type="checkbox" name={item.id} onChange={this.onCheckBox} />
									<span class={s.item}>{item.text}</span>
								</label>
							</li>
						);
					})}
				</ul>
			</div>
		);
	}

	render(props, state) {
		const { sections, checklist } = props;
		const { navOpen } = state;

		return (
			<header class={s.wrapper}>
				<button class={joinClasses(s.burger, navOpen && s.open)} onClick={this.toggleNavOpen}>
					<div class={joinClasses(s.line, s.top)} />
					<div class={joinClasses(s.line, s.middle)} />
					<div class={joinClasses(s.line, s.bottom)} />
				</button>
				{this.renderNav(sections, checklist)}
			</header>
		);
	}
}
